module.exports = __webpack_public_path__ + "static/img/视频_mp4@2x.58f240e3.png";